import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import SideBar from "../components/SideBar";
import { Typography, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";

export default function AllUsers() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "shipments.xlsx");
  };
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true); // تفعيل حالة التحميل
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const runnerID = userData.runnerID;
        const response = await axios.get(
          `https://vsoftrunners.com-eg.net/api/RunnerUsers/V7/GetAllShipments/${runnerID}`,
          {
            headers: {
              CompanyID: "212606",
              AccessToken: userData.accessToken,
            },
          }
        );

        if (response.data.notCollectedShipments) {
          const formattedUsers = response.data.notCollectedShipments.map(
            (user, index) => ({
              ...user,
              id: user.awb || index,
            })
          );
          setUsers(formattedUsers);
        } else {
          console.error("No notCollectedShipments found.");
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        if (error.response && error.response.status === 401) {
          console.log("Session expired, logging out...");
          localStorage.removeItem("userData"); // مسح بيانات المستخدم
          navigate("/"); // إعادة التوجيه إلى الصفحة الرئيسية
        }
      } finally {
        setLoading(false); // إخفاء حالة التحميل
      }
    };

    fetchUsers();
  }, []);

  const columns = [
    { field: "awb", headerName: t("AWB"), width: 120 },
    { field: "consigneeName", headerName: t("Consignee Name"), width: 150 },
    { field: "mobile", headerName: t("Mobile"), width: 150 },
    { field: "tel1", headerName: t("telephone"), width: 150 },
    { field: "cityName", headerName: t("City Name"), width: 150 },
    { field: "contents", headerName: t("contents"), width: 150 },
    {
      field: "specialInstructions",
      headerName: t("specialInstructions"),
      width: 250,
    },
    { field: "cod", headerName: t("cod"), width: 120 },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <SideBar
        open={isSideBarOpen}
        toggleOpen={() => setIsSideBarOpen(!isSideBarOpen)}
      />
      <Box
        sx={{
          height: "calc(100vh - 180px)",
          width: "95%",
          marginTop: "70px",
          marginLeft: isSideBarOpen ? "5px" : "250px",
          transition: "margin-left 0.3s",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginBottom: "20px",
            fontWeight: "bold",
            color: "#263150",
            marginRight: "10px",
          }}
        >
          {t("allUser")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          onClick={exportToExcel}
          sx={{ mb: 2 }}
        >
          {t("Export to Excel")}
        </Button>
        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={users}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableRowSelectionOnClick
            sx={{
              marginRight: "10px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "red",
                color: "#63729A",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#324c95",
                color: "white",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#e0e0e0",
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
}
